import { render, staticRenderFns } from "./ErpIcmDbBackup.vue?vue&type=template&id=1b86565e&scoped=true&"
import script from "./ErpIcmDbBackup.vue?vue&type=script&lang=js&"
export * from "./ErpIcmDbBackup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b86565e",
  null
  
)

export default component.exports